import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "disablePage" }
const _hoisted_2 = { id: "not-found-header" }
const _hoisted_3 = { id: "not-found-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
      _createElementVNode("div", { class: "spinner" }, null, -1 /* CACHED */)
    ]))], 512 /* NEED_PATCH */), [
      [_vShow, !_ctx.siteIsInitialized]
    ]),
    _createElementVNode("section", null, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", null, _toDisplayString(_ctx.offerExpiredHeadlineText), 1 /* TEXT */)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", null, _toDisplayString(_ctx.pleaseContact) + " " + _toDisplayString(_ctx.DepartmentName) + " " + _toDisplayString(_ctx.onPhone) + " " + _toDisplayString(_ctx.Phone) + " " + _toDisplayString(_ctx.orOn) + " " + _toDisplayString(_ctx.Email) + " " + _toDisplayString(_ctx.forFurtherInformation), 1 /* TEXT */)
      ])
    ])
  ], 64 /* STABLE_FRAGMENT */))
}